import http from '@/utils/http'
import httpApi from '@/apis/httpApi'
// 获取插件版本
export const getPluginVersion = () => {
    return http.usualPost({
        url: httpApi.plugin.getVersion,
        data: {}
    })
}